import { useSearchParams } from 'react-router-dom'
import { WorkflowBuilderPage } from 'app/components/workflows/WorkflowBuilderPage'
import { WorkflowsGate } from 'app/components/workflows/WorkflowsGate'

export const handle = {
  title: `New workflow`,
  breadcrumb: `New workflow`,
}

export default function WorkflowsNewView() {
  const [searchParams] = useSearchParams()
  return (
    <WorkflowsGate>
      <WorkflowBuilderPage mode="new" templateId={searchParams.get(`template`) ?? undefined} />
    </WorkflowsGate>
  )
}
